import { useNavigate } from "react-router-dom";
import { Users, ClipboardList, UserCheck, CalendarPlus, Calendar, User, FileText, Image, Settings, TrendingUp } from "lucide-react";
import Header from "../components/aesthetics/dashboard/Header";
import StatCard from "../components/aesthetics/dashboard/StatCard";
import ActionButton from "../components/aesthetics/dashboard/ActionButton";
import UpcomingTreatments from "../components/aesthetics/dashboard/UpcomingTreatments";
import TreatmentStats from "../components/aesthetics/dashboard/TreatmentStats";
import ClientActivity from "../components/aesthetics/dashboard/ClientActivity";

const AestheticDashboard = () => {
  const navigate = useNavigate();

  const handleNewBooking = () => {
    navigate("/aesthetics/bookings?newBooking=true");
  };

  const handleCalendar = () => {
    navigate("/aesthetics/calendar");
  };

  const handleClients = () => {
    navigate("/aesthetics/clients");
  };

  const handleTreatmentsConsents = () => {
    navigate("/aesthetics/treatments");
  };

  const handleGallery = () => {
    navigate("/aesthetics/gallery");
  };

  const handleSettings = () => {
    navigate("/aesthetics/settings");
  };

  return (
    <div className="min-h-screen bg-background p-6 md:p-8">
      <div className="mx-auto">
        <Header />
        
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6 animate-fade-in">
          <StatCard icon={Users} label="Employees" value={8} />
          <StatCard icon={ClipboardList} label="Today's Treatments" value={12} />
          <StatCard icon={UserCheck} label="Total Clients" value={249} />
          <StatCard icon={TrendingUp} label="This Month" value={114} />
        </div>
        
        {/* Action Buttons */}
        <div className="flex flex-wrap gap-3 mb-6 animate-fade-in" style={{ animationDelay: "0.1s" }}>
          <ActionButton icon={CalendarPlus} label="New Booking" onClick={handleNewBooking} />
          <ActionButton icon={Calendar} label="Calendar" onClick={handleCalendar} />
          <ActionButton icon={User} label="Clients" onClick={handleClients} />
          <ActionButton icon={FileText} label="Treatments" onClick={handleTreatmentsConsents} />
          <ActionButton icon={Image} label="Gallery" onClick={handleGallery} />
          <ActionButton icon={Settings} label="Settings" onClick={handleSettings} />
        </div>
        
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 animate-fade-in" style={{ animationDelay: "0.2s" }}>
          <UpcomingTreatments />
          <TreatmentStats />
        </div>
        
        {/* Client Activity */}
        <div className="animate-fade-in" style={{ animationDelay: "0.3s" }}>
          <ClientActivity />
        </div>
      </div>
    </div>
  );
};

export default AestheticDashboard;
